<template>
  <div
    class="ce-mobileDocResult-group"
    :class="{'group-open': groupOpen}">
    <div v-if="!hasMultipleAssets">
      <component
        :is="assetResultComponent"
        :key="firstAsset.id"
        :asset="firstAsset"
        :product="product" />
    </div>
    <div
      class="ce-mobileDocResult-groupWrapper"
      v-else>
      <div class="ce-mobileDocResult-header">
        <div class="ce-mobileDocResult-actionsBefore">
          <div class="ce-documentResult-rowToggle">
            <a
              href=""
              @click.prevent="toggleGroup">
              <fa-icon icon="angle-down" />
            </a>
          </div>

          <div class="ce-documentResult-selectCta">
            <checkbox
              class="ce-checkbox--small"
              :id="`${assets[0].type}-group`"
              :value="isInBasket"
              :partially-checked="partiallyInBasket"
              @input="toggleBasket"
              :show-label="false" />
          </div>

          <result-state-indicators
            v-if="isMySheets"
            :show-new="hasNewDocuments"
            :show-updated="hasNewDocumentVersions" />
        </div>
        <div
          class="ce-mobileDocResult-name"
          @click.prevent="toggleGroup">
          {{ typeLabel }}
        </div>
      </div>

      <transition
        :css="false"
        @enter="enterAnimation"
        @leave="leaveAnimation">
        <div
          v-if="groupOpen">
          <component
            :is="assetResultComponent"
            v-for="asset in assets"
            :key="asset.id"
            :asset="asset"
            :locale-level="true"
            :product="product" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import DocumentResultGroup from 'mixins/product-sheets/DocumentResultGroup';

export default {
  mixins: [DocumentResultGroup]
};
</script>

<style lang="less">
  @import (reference) '~styles/includes/base';

  .ce-mobileDocResult {
    .ce-mobileDocResult-group {
      .ce-mobileDocResult-header {
        .ce-mobileDocResult-name {
          .ms(0)
        }
      }

      .ce-mobileDocResult-groupWrapper {
        padding-left: @space-4;

        @media screen and (min-width: @breakpoint-xs) {
          padding-left: 66px;
        }
      }
    }
  }
</style>
